import * as React from "react";
import { SortableElement } from "react-sortable-hoc";

interface ISortableItemProps<T> {
  key: number;
  item: T;
  index: number;
  renderItem: (value: T) => React.ReactNode;
}

const MUI_MODAL_Z_INDEX = 1300;

export default class SortalbeItem<T> extends React.PureComponent<
  ISortableItemProps<T>
> {
  private SortableItem = SortableElement(({ value }: any) => {
    return (
      <div style={{ zIndex: MUI_MODAL_Z_INDEX }}>
        {this.props.renderItem(value)}
      </div>
    );
  });

  public render() {
    const { item, index } = this.props;
    return <this.SortableItem index={index} value={item} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/sortableList/SortableItem.tsx